import { Button, Col, Icon, Input, Popover, Radio, Row, Spin, Typography } from 'antd';
import Form, { FormComponentProps } from 'antd/lib/form/Form';
import React from 'react';
import { O2OFormItem } from './O2OFormItem';
import _ from 'lodash';
import Scrollbars from 'react-custom-scrollbars';

type Item = {
  key: string;
  name: string;
};

interface IFilterSortData extends FormComponentProps {
  isLoading?: boolean;
  items: Item[];
  orderBy?: string;
  onChangeOrderBy: (e: any) => void;
}

export const FilterSortData = Form.create<IFilterSortData>()((props: IFilterSortData) => {
  const [visible, setVisible] = React.useState<boolean>(false);
  const { getFieldDecorator } = props.form;

  React.useEffect(() => {
    if (visible && props.orderBy) {
      props.items.map((item: any, index: number) => {
        props.form.resetFields([`name_${index}`]);
      });

      const splitOrder = props.orderBy.split(':');
      const s = splitOrder[0];
      const o = splitOrder[1];
      const findIndexFieldName = _.findIndex(props.items, (item: any) => item.key === s);
      if (findIndexFieldName === -1) return;

      props.form.setFieldsValue({
        [`name_${findIndexFieldName}`]: true,
        [`sort_${findIndexFieldName}`]: o,
      });
    }
  }, [visible, props.orderBy]);

  const renderButtonSort = () => {
    if (!props.orderBy || !props.items.length)
      return (
        <Button type={visible ? 'primary' : 'default'}>
          <Icon type='sort-descending' />
        </Button>
      );
    const splitOrder = props.orderBy.split(':');
    const s = splitOrder[0];
    const o = splitOrder[1];
    const findIndexFieldName = _.findIndex(props.items, (item: any) => item.key === s);
    if (findIndexFieldName === -1) return '';

    return (
      <>
        <Button
          onClick={() => {
            setVisible(true);
          }}
          style={{ padding: 0, display: 'flex', alignItems: 'center' }}
          size='small'
          type='link'
        >
          {o === 'desc' ? (
            <Icon type='sort-ascending' style={{ color: '#000000' }} />
          ) : (
            <Icon type='sort-descending' style={{ color: '#000000' }} />
          )}
          <span className='mr4 txt-black-color-60'>Sort by</span>
          {props.items[findIndexFieldName].name} - {o === 'desc' ? 'DESC' : 'ASC'}{' '}
          <Icon style={{ marginLeft: 4 }} type='caret-down' />
        </Button>
      </>
    );
  };

  const onHandleSort = (index: number, item: Item) => {
    const keySort = props.form.getFieldValue(`sort_${index}`) === 'desc' ? 'asc' : 'desc';
    props.form.setFieldsValue({ [`sort_${index}`]: keySort });
    if (props.form.getFieldValue(`name_${index}`)) props.onChangeOrderBy(`${item.key}:${keySort}`);
  };

  return (
    <Popover
      visible={visible}
      onVisibleChange={(e: boolean) => {
        setVisible(e);
      }}
      trigger='click'
      placement='leftTop'
      title={
        <Typography.Text className='txt-black-color-75' strong>
          Sorting
        </Typography.Text>
      }
      content={
        <Scrollbars autoHeight autoHide={true}>
          <Col style={{ padding: '0 8px 0 8px' }}>
            <Form hideRequiredMark={true} colon={false}>
              {props.items &&
                props.items.map((item, index) => {
                  const splitOrder = props.orderBy?.split(':');
                  const findIndexFieldName = _.findIndex(props.items, (item: any) => item.key === splitOrder?.[0]);

                  return (
                    <Row key={item.key} gutter={[5, 5]} align='middle' justify='space-between' type='flex'>
                      <Col style={{ marginRight: 'auto' }}>
                        <O2OFormItem>
                          {getFieldDecorator(`name_${index}`, {
                            valuePropName: 'checked',
                          })(
                            <Radio
                              value={item.name}
                              onClick={() => {
                                if (findIndexFieldName === index) return;
                                const sort = props.form.getFieldValue(`sort_${index}`);
                                props.onChangeOrderBy(`${item.key}:${sort}`);
                              }}
                            >
                              {item.name}
                            </Radio>
                          )}
                        </O2OFormItem>
                      </Col>

                      <Spin spinning={props.isLoading && findIndexFieldName === index}>
                        <Col>
                          <Button
                            style={{ display: 'flex', alignItems: 'center', paddingRight: '1px', width: 68 }}
                            size='small'
                            type='link'
                            onClick={() => onHandleSort(index, item)}
                          >
                            <Icon type='swap' />{' '}
                            {(props.form.getFieldValue(`sort_${index}`) || 'desc') === 'desc' ? ' DESC' : 'ASC'}
                          </Button>
                        </Col>
                      </Spin>

                      {getFieldDecorator(`sort_${index}`, { initialValue: 'desc' })(
                        <Input style={{ display: 'none' }} />
                      )}
                    </Row>
                  );
                })}
            </Form>
          </Col>
        </Scrollbars>
      }
    >
      {renderButtonSort()}
    </Popover>
  );
});
